import React, { forwardRef } from 'react';

import classNames from 'classnames';

type OptionProps = {
  id: string;
  isActive?: boolean;
  label?: number | string;
  value: string;
};

export const Option = forwardRef<HTMLLIElement, OptionProps>(
  ({ id, isActive = false, label, value, ...otherProps }, ref) => {
    const optionProps = {
      'aria-label': label as string,
      'aria-selected': isActive,
      'data-label': label,
      className: classNames(
        'block py-2.5 px-5 text-sm hover:bg-gray-50 text-gray-950',
        { 'md:bg-gray-100 bg-gray-50': isActive },
      ),
      label,
      role: 'option',
      tabIndex: -1,
      value,
      id,
      ref,
      ...otherProps,
    };

    return <li {...optionProps}>{label}</li>;
  },
);
